import React from 'react';
import { useRecoilState } from 'recoil';
import './index.scss';
import {
  onHoldModalDisplayState,
  showModalForMonthlyRevenueState,
} from '../../recoil-state/request-funding-states';
import BankInfoModal from './BankInfoForModal';
import {
  accountRecordState,
  isPlaidConnectedState,
  openOppHasBankStatementsState,
} from '../../recoil-state/general-states';
import { showSubmittedModalState } from '../../recoil-state/application-stage-states';
import SignNewContract from '../Application/SignAgreements/newContract';
import PayroInput from '../../widgets/PayroInput';
import PayroButton from '../../widgets/PayroButton';
import { GetAccountDto } from '../../api-utils/generated-client';
import { getClient } from '../../api-utils/general-utils';

const MonthlyFundingModal = () => {
  const [accountDetails, setAccountDetails] =
    useRecoilState<GetAccountDto>(accountRecordState);
  const [modalDisplayMonthlyRevenue, setShowModalForMonthlyRevenue] =
    useRecoilState(showModalForMonthlyRevenueState);
  const [isConnected] = useRecoilState(isPlaidConnectedState);
  const [showSubmittedModal] = useRecoilState(
    showSubmittedModalState,
  );

  const closeModal = async () => {
    await setShowModalForMonthlyRevenue('modal display-none');
  };
  const saveMonthlyRevenueAmount = async (
    monthlyRevenueAmount: number,
  ) => {
    console.log('DraftDeal', accountDetails);

    await setAccountDetails({
      ...accountDetails,
      monthlyrevenue: monthlyRevenueAmount,
    });
    const client = await getClient();
    if (!client) {
      return;
    }
    await client
      .accountsControllerUpdate({
        monthlyrevenue: monthlyRevenueAmount,
      })
      .then(async () => {
        const res = await client.accountsControllerGetMyInfo();
        console.log(res, 'res');
      });
  };

  return (
    <div className={modalDisplayMonthlyRevenue}>
      <div className={`modal-content`}>
        <span onClick={closeModal} className="close">
          &times;
        </span>
        <p className="modal-header-on-hold">We Need a Quick Update</p>
        <p className="on-hold-message-text">
          {' '}
          Please update your average monthly revenue in order to
          proceed.
        </p>
        <div className="monthly-revenue-modal-wrapper">
          <PayroInput
            onBlurFunction={(e: any) => {
              saveMonthlyRevenueAmount(
                parseFloat(e.target.value),
              ).then(() => {});
            }}
            isOnlyNumbers
            placeholder="0.00"
            value={accountDetails.monthlyrevenue ?? 0}
            onChange={(eventValue: any) => {
              if (eventValue) {
                setAccountDetails({
                  ...accountDetails,
                  monthlyrevenue: parseFloat(eventValue),
                });
              }
            }}
            label="Average Monthly Revenue"
            subLabel={''}
            variant="white"
            type="currency"
            // error={!accountDetails.monthlyrevenue}
          />
        </div>{' '}
        <div className="support-button-wrapper ">
          {' '}
          <PayroButton
            onClick={async () => {
              if (accountDetails.monthlyrevenue) {
                await closeModal();
              }
            }}
            disabled={!accountDetails.monthlyrevenue}
          >
            Save
          </PayroButton>
        </div>
      </div>
    </div>
  );
};

export default MonthlyFundingModal;
